import Vue from 'vue'
import util from './util.js';
import Router from 'vue-router'


import {
	Toast,
	Dialog
} from 'vant';

/* https://youzan.github.io/vant/#/zh-CN/toast */
Vue.use(Toast, Dialog)
/**
 * 基于UNI-APP 封装API接口 
 */
let cstUni = {}

// 判断是否APP环境
cstUni.isApp = util.userAgent().isApp;

// 获取当前浏览器 userAgent 
cstUni.userAgent = util.userAgent();

// 判断是否function 
cstUni.isFn = function(fun) {
	return typeof fun === 'function'
}

/**
 * 显示提示信息
 * vant toast api https://youzan.github.io/vant/#/zh-CN/toast
 * complete 该方法：close success 都会返回
 * close  	该方法 页面关闭后回调，
 * success 	该方法 当页面显示成功后会返回
	cstUni.showToast({
		title:"你好啊",
		duration:"5000",
		complete:(toast)=>{
			setTimeout(function() {
				toast.message  = "改变文字哦~";
			}, 800 );
		},
		close:(toast)=>{
			console.log( "close" )
		},
		success:(toast)=>{
			console.log( "success" )
		}
	})
 */
cstUni.showToast = function(data) {
	const showToast = Toast({
		type: data.icon ? data.icon : "text",
		message: data.title ? data.title : "",
		mask: false,
		forbidClick: data.mask ? data.mask : true,
		duration: data.duration ? data.duration : 1500,
		onOpened: () => {
			typeof data.complete == "function" && data.complete(showToast)
		},
		onClose: () => {
			typeof data.close == "function" && data.close(showToast)
			typeof data.complete == "function" && data.complete(showToast)
		}
	});
	typeof data.success == "function" && data.success(showToast)
	typeof data.complete == "function" && data.complete(showToast)
}

/**
 * 显示加载框 loading 
 */
cstUni.showLoading = function(data) {
	const showLoading = Toast.loading(data)
	return showLoading;
}

/**
 * 隐藏加载框 loading 
 */
cstUni.hideLoading = function() {
	return Toast.clear();
};

/**
 * 显示提示框 
 * 参数参考： https://uniapp.dcloud.io/api/ui/prompt?id=showmodal 
 */
cstUni.showModal = function(info) {
	var buttons = [],
		data = {};
	try {
		if (info.showCancel == undefined || info.showCancel == true) {
			buttons.push(info.cancelText || "取消");
		}
		buttons.push(info.confirmText || "确定");
		data.content = info.content || "";
		data.title = info.title || "";
		var callback = {
			cancel: false,
			confirm: true
		};
		if (cstUni.isApp && info.plus) {
			// app 环境 
			plus.nativeUI.confirm(data.content, function(res) {
				if (info.showCancel && info.showCancel == true) {
					if (res.index == 0) {
						callback = {
							cancel: true,
							confirm: false
						}
					}
				}
				typeof info.success == "function" && info.success(callback)
			}, data.title, buttons);
		} else {
			Dialog({
				title: data.title,
				message: data.content,
				messageAlign: "center",
				showConfirmButton: true,
				showCancelButton: info.showCancel ? info.showCancel : false,
				cancelButtonText: info.cancelText ? info.cancelText : "取消",
				confirmButtonText: info.confirmText ? info.confirmText : "确定",
				overlay: true,
			}).then(() => {
				typeof info.success == "function" && info.success(callback)
			}).catch(() => {
				typeof info.success == "function" && info.success({
					cancel: true,
					confirm: false
				})
			})
		}
	} catch (e) {
		typeof info.fail == "function" && info.fail({
			errCode: 0,
			errMsg: "参数错误"
		})
	}
}

/**
 *  页面跳转 可以使用 catch 扑获 error 
	cstUni.navigateTo({
		url:"/detail?id="+e.itemid+"&shopType="+e.shopType
	}).then(r=>{
		console.log( r )
	}).catch(err=>{
		console.log( err )
	})
 */
cstUni.navigateTo = function(data) {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			if (data.h5) {
				location.href = data.url;
			} else {
				if (typeof succ == "function") {
					uni.navigateTo(data)
					succ({
						errCode: 0,
						errMsg: "跳转成功"
					})
				}
			}
		} else {
			error({
				errCode: 1,
				errMsg: "跳转失败"
			})
		}
	});
}

/**
 *  TAB 跳转  catch 扑获 非APP 
	cstUni.switchTab({
		url:"/detail?id="+e.itemid+"&shopType="+e.shopType
	}).then(r=>{
		console.log( r )
	}).catch(err=>{
		console.log( err )
	})
 */
cstUni.switchTab = function(data) {
	return new Promise((succ, error) => {
		if (uni.isApp) {
			console.log("uni: " + JSON.stringify(uni));
			if (typeof succ == "function") {
				uni.switchTab(data)
				succ({
					errCode: 0,
					errMsg: "跳转成功"
				})
			}
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}

/**
 *  页面返回 可以使用 catch 扑获 非APP 
	uni.navigateBack({
		delta:1,
	}).then(r=>{
		console.log( r )
	}).catch(err=>{
		console.log( err )
	})
 */
cstUni.navigateBack = function(data) {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			if (typeof succ == "function") {
				uni.navigateBack(data)
				succ({
					errCode: 0,
					errMsg: "跳转成功"
				})
			}
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}


/**
 *  关闭当前页面，跳转到应用内的某个页面。 可以使用 catch 扑获 非APP 
	cstUni.redirectTo({
		delta:1,
	}).then(r=>{
		console.log( r )
	}).catch(err=>{
		console.log( err )
	})
 */
cstUni.redirectTo = function(data) {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			if (typeof succ == "function") {
				uni.redirectTo(data)
				succ({
					errCode: 0,
					errMsg: "跳转成功"
				})
			}
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}

/**
关闭所有页面，打开到应用内的某个页面。
 */
cstUni.reLaunch = function(data) {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			if (typeof succ == "function") {
				uni.reLaunch(data)
				succ({
					errCode: 0,
					errMsg: "跳转成功"
				})
			}
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}

/**
 *	suni.postMessage({
		data: {
			action: 'api', // 方法 api 则调用uniapp端的api
			methods:"setNavigationBarTitle", // 调用某个方法
			params:{
				title:"哈哈哈"
			}
		}
	});
 */
cstUni.postMessage = function(data) {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			if (typeof succ == "function") {
				uni.postMessage({
					data: data
				});
				succ({
					errCode: 0,
					errMsg: "跳转成功"
				})
			}
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}

/**
 * APP环境下返回 h+ api  可以使用5+ API 扩展 
 * http://www.html5plus.org/doc/zh_cn/device.html#
 * 非APP环境 则返回失败 
	cstUni.plus().then(plus=>{
		plus.nativeUI.toast(  plus.device.uuid );
	}).catch(err=>{
		console.log( err )
	})
 */
cstUni.plus = function() {
	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			typeof succ == "function" ? succ(plus) : ""
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}


/**
 * 设置当前的webview
 */
cstUni.getCurrentWebview = function() {

	return new Promise((succ, error) => {
		if (cstUni.isApp) {
			var currentWebview = plus.webview.currentWebview();
			typeof succ == "function" ? succ(currentWebview) : ""
		} else {
			typeof error == "function" ? error({
				errCode: 1,
				errMsg: "请求来源异常"
			}) : ""
		}
	});
}



export default cstUni;
